
export default {
    "reparterold": "0x2C54036c505B762B6cA2873dfcfEcB632f83fE27",
    "reparter": "0x0515023dc5ab2a88713ab5a03011e56ea754ad6f",
    "token": "0x3A9FfF453d50D4Ac52A6890647b823379ba36B9E",
    //"RaffleDapp": "0x3148b75D722f8A14C56482D95305Ffe0120f1277", //ropsten
    //"RaffleDapp": "0xC7C94a74E7A000dEb18170be0C7e1Db5353E3Eb9", //mainnet test
    "RaffleDapp": "0x1235f3f2bB5f69BcEB5425CDc83cB1163190D9bB",
    //live 0xa2D9206889b3d79165B9e0DdeF97104F176fE610
    //"TokenContract": "0x26B3B5B554df7a8a56c05511affa5664fD3641B5",
    "TokenContract": "0x3A9FfF453d50D4Ac52A6890647b823379ba36B9E",
    "ethNode": "https://node.rcn.loans/",
    "ethNode2": "https://mainnet.infura.io/v3/1020c96081ca4086afa51d6dd2a4e8fe",
    "ethNodeR": "https://ropsten.infura.io/v3/1020c96081ca4086afa51d6dd2a4e8fe",
    "ethNodeRsocket": "wss://ropsten.infura.io/ws/v3/1020c96081ca4086afa51d6dd2a4e8fe",
    "ethNodesocket": "wss://mainnet.infura.io/ws/v3/1020c96081ca4086afa51d6dd2a4e8fe",
    //wss://ws.web3api.io
    "tokenuniswap":"0x536956Fab86774fb55CfaAcF496BC25E4d2B435C"
}
